<template>
  <div>
    <img class="w-100percent mt--2" src="@/assets/images/wave.svg"/>
    <div id="how-it-works" class="bg-white">

      <div class="text-center container-narrow mx-auto mt-32">
        <h6 class="text-secondary-500">
          Semen Assessment
        </h6>

        <h2 class="mt-2">
          How it works
        </h2>
      </div>

      <div class="pt-0 pb-32 container">

        <div class="md:flex flex-row sm:flex-col md:flex-row lg:flex-row xl:flex-row mt-32">
          <img class="retina" src="@/assets/images/collect-a-sample.jpg" alt="First Options Fertility - Semen Sample Collection"/>

          <div class="md:mx-12 align-center flex flex-col justify-center">
            <h2 class="mt-0 mb-0">
              Collect a sample
            </h2>
            <h3 class="mt-0 mb-4 text-secondary-500">
              At home or in the clinic
            </h3>
            <p class="text-navy-400">
              Detailed information will be given to you prior to your appointment on how best to produce the sample and maintain it’s integrity prior to analysis. You can produce the sample in the comfort of your own home into a sterile sample container and bring it to the testing clinic within 1 hour of production. Alternatively you can produce your sample on-site in the clinic.
            </p>
          </div>
        </div>

        <div class="md:flex flex-row sm:flex-col md:flex-row-reverse lg:flex-row-reverse xl:flex-row-reverse mt-32">
          <img class="retina" src="@/assets/images/analyse-the-semen.jpg" alt="First Options Fertility - Analyse Semen Sample"/>

          <div class="md:mx-12 align-center flex flex-col justify-center">
            <h2 class="mt-0">
              Analyse the sample
            </h2>
            <p class="text-navy-400">
              We will conduct a suite of analyses including sperm concentration, morphology, motility, volume, pH, viscosity and agglutination with anti-sperm antibody binding testing where appropriate. Additional more in-depth testing can also be conducted. <a class="text-primary-500" href="#services">Learn more</a>
            </p>
          </div>
        </div>

        <div class="md:flex flex-row sm:flex-col md:flex-row lg:flex-row xl:flex-row mt-32">
          <img class="retina" src="@/assets/images/create-a-report.jpg" alt="First Options Fertility - Semen Sample Report"/>

          <div class="md:mx-12 align-center flex flex-col justify-center">
            <h2 class="mt-0">
              Create a report
            </h2>
            <p class="text-navy-400">
              Your results will be cross-checked against defined World Health Organisation standards producing your individual tailored report.
            </p>
          </div>
        </div>

        <div class="md:flex flex-row sm:flex-col md:flex-row-reverse lg:flex-row-reverse xl:flex-row-reverse mt-32">
          <img class="retina" src="@/assets/images/receive-your-results.jpg" alt="First Options Fertility - Receive your Semen Sample"/>

          <div class="md:mx-12 align-center flex flex-col justify-center">
            <h2 class="mt-0">
              Receive your results
            </h2>
            <p class="text-navy-400">
              You will receive your results on the same day as your semen assessment. During your phone consultation we will walk you through your test results and guide you on your fertility journey.
            </p>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'HowSection',
}
</script>

<style scoped>
.retina {
  max-width: 50%;
}

@media only screen and (max-width: 600px) {
  .retina {
    max-width: 80%;
    margin-bottom: 20px;
  }
}

.mt--2 {
  margin-top: -2px;
}
</style>
